<template lang="pug">
.row.report-list
</template>

<script>
export default {
  name: 'report-list'
}
</script>



// WEBPACK FOOTER //
// report-list.vue?64b91960